"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAxiosInstance = exports.setAxiosInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const instance = axios_1.default.create({});
let axiosInstance = instance;
const setAxiosInstance = (value) => {
    axiosInstance = value;
};
exports.setAxiosInstance = setAxiosInstance;
const getAxiosInstance = () => {
    return axiosInstance;
};
exports.getAxiosInstance = getAxiosInstance;
